if (!customElements.get("rook-countdown-timer")) {
  if (!customElements.get("rook-countdown-timer")) {
    class MCountdownTimer extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        const time = this.dataset.time;
        const endTime = Date.parse(time.split(" ").join("T"));
        if (endTime) {
          new CountdownTimer(this, Date.now(), endTime, { type: this.dataset.type, duration: this.dataset.duration });

          if (endTime > Date.now()) {
            this.classList.remove("hidden");
            this.classList.remove("rook:hidden");
          }
        }
      }
    }

    customElements.define("rook-countdown-timer", MCountdownTimer);
  }
}
